export interface ISharePercentageResponse {
  amount: number;
  average_price: number;
  party_name: string;
  participation_percentage: number;
  side: string;
  trades: number;
  volume: number;
}

export interface ISharePercentageDigitalResponse {
  amount: number;
  averagePrice: number;
  casaBolsa: string;
  companySharePercentage: number;
  descriptionOper: string;
  numOper: number;
  volume: number;
}

export interface ISharePercentage {
  amount: number;
  averagePrice: number;
  partyName: string;
  participationPercentage: number;
  side: string;
  trades: number;
  volume: number;
}

export class SharePercentageViewModel implements ISharePercentage {
  static fromJSON(json: ISharePercentageResponse): SharePercentageViewModel {
    const SHARE_PERCENTAGE_SIDE: any = {
      Buy: 'Compra',
      Sell: 'Venta',
      Cross: 'Cruce',
    };

    return new SharePercentageViewModel(
      json.amount,
      json.average_price,
      json.party_name,
      json.participation_percentage,
      SHARE_PERCENTAGE_SIDE[json.side],
      json.trades,
      json.volume,
    );
  }

  static fromDigitalJSON(
    json: ISharePercentageDigitalResponse,
  ): SharePercentageViewModel {
    return new SharePercentageViewModel(
      json.amount,
      json.averagePrice,
      json.casaBolsa,
      json.companySharePercentage,
      json.descriptionOper,
      json.numOper,
      json.volume,
    );
  }

  constructor(
    public amount: number,
    public averagePrice: number,
    public partyName: string,
    public participationPercentage: number,
    public side: string,
    public trades: number,
    public volume: number,
  ) {}
}
